import { UserRolePagesMapping } from './user-role-pages-mapping.model';
import { Role } from './role.model';


export class AccessControl {
  constructor(
        public userRolePageMappingList ?: UserRolePagesMapping[],
        public roleList?: Role[],
        public roleId?:number,
    ) {
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/model/access-control.model.ts